import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import AppointmentReminder from '../components/AppointmentReminder';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    conversations: state.conversations,
    business: state.business,
    auth: state.auth,
    staffManagement: state.StaffManagement,
    conversationDetails: state.conversationDetails,
    appointmentreminder: state.AppointmentReminder,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppointmentReminder);
